import  firebase from 'firebase'
import 'firebase/auth'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyCiFnLXxKdqF17JRxIyDuDM3zloklektFk",
  authDomain: "loginreact-d780f.firebaseapp.com",
  projectId: "loginreact-d780f",
  storageBucket: "loginreact-d780f.appspot.com",
  messagingSenderId: "639917034481",
  appId: "1:639917034481:web:9a325b110976420fc7d250",
  measurementId: "G-GKB2XYEZCN"
};
// Initialize Firebase
const fire = firebase.initializeApp(firebaseConfig);
      
const auth = fire.auth();
export{auth}